import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["rows"]

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { useVModel } from '@vueuse/core';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Textarea',
  props: {
    defaultValue: {},
    modelValue: {},
    rows: { default: 3 },
    class: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emits = __emit;

    const modelValue = useVModel(props, 'modelValue', emits, {
        passive: true,
        defaultValue: props.defaultValue,
    });

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("textarea", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
    "data-slot": "textarea",
    rows: _ctx.rows,
    class: _normalizeClass(
            _unref(cn)(
                'placeholder:text-faded-foreground selection:bg-primary selection:text-primary-foreground border-input flex w-full min-w-0 rounded-md border bg-transparent px-2.5 py-1.5 text-xs shadow-xs transition-[color,box-shadow] outline-none placeholder:text-xs',
                'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                'disabled:bg-faded disabled:pointer-events-none disabled:cursor-not-allowed',
                props.class,
            )
        )
  }, null, 10, _hoisted_1)), [
    [_vModelText, _unref(modelValue)]
  ])
}
}

})